import { createFileRoute } from "@tanstack/react-router";
import { MfeLoader } from "../mfe/MfeLoader";
import { getAgentGatewayHostConfig } from "../config/agentGatewayHostConfig";
import { useHostNavigate } from "../hooks/useHostNavigate";

export const Route = createFileRoute("/agent-gateway/$")({
  component: AgentGatewayMfePage,
});

function AgentGatewayMfePage() {
  const onNavigate = useHostNavigate();
  return (
    <MfeLoader
      name="agent-gateway"
      props={{ hostConfig: getAgentGatewayHostConfig(onNavigate) }}
    />
  );
}
